<template>
  <b-form @reset="reset" onsubmit="return false">
    <b-input-group size="sm">
      <b-form-input
        v-model.trim="form.searchKey"
        :placeholder="$l('INDEX.form_label_choose_sys_user') || '姓名/公司/部门 搜索...'"
        type="search"
        @keyup.enter="query"
      />
      <b-input-group-append>
        <b-button-group slot="reference">
          <b-button variant="primary" size="sm" @click="query">
            <i class="fa fa-search" />
          </b-button>
        </b-button-group>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>

<script>
const initForm = { searchKey: '', userStatusList: ['Y'] }

export default {
  data() {
    return { form: { ...initForm } }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', this.form)
    },
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>

<style lang="scss" scoped></style>
